/**
 * Snapshot-Verzicht mit optionaler Begründung. Seit 18.09.2026 sind
 * Begründung und Ersatzsicherungs-Beleg freiwillige Notizen (Entscheid Colin:
 * ein Betreiber, keine Rechtfertigung vor sich selbst); das Backend prüft
 * keine Länge mehr. Die Beispiele bleiben als Platzhalter.
 */

export const VERZICHT_BEISPIEL =
  'Ceph-Pool bei 84,83 % (nearfull 85 %), ein Snapshot würde ihn über die ' +
  'Schwelle schieben; Sicherung liegt als PBS-Backup vor';
export const BELEG_BEISPIEL = 'PBS 20.08. 00:30, alle 6 VMs, verify ok';

/** Zeilenumbrüche und Mehrfach-Leerzeichen für die Notiz am Lauf zusammenschieben. */
export function eineZeile(text: string): string {
  return text.split(/\s+/).filter(Boolean).join(' ');
}
